import { useEffect, useState } from 'react';
import { message } from 'antd';
import OrderInfo from './orderInfo';
import { bxGetOrderIdForCurrentDeal, bxSaveOrderIdForCurrentDeal } from '@lib/bx24';
import { GuaranteeStartFormWrapper } from './guranteeStartFormWrapper';

export default function OrderTab() {
  const [loadingInitial, setLoadingInitial] = useState(true);
  const [orderId, setOrderId] = useState<string | null>(null);

  // 1) При инициализации читаем orderId из FZ_ORDER
  useEffect(() => {
    if (loadingInitial) {
      (async () => {
        try {
          const existingOrderId = await bxGetOrderIdForCurrentDeal();
          if (existingOrderId) {
            setOrderId(existingOrderId);
          }
        } catch (e) {
          console.warn('OrderTab: не удалось прочитать orderId из FZ_ORDER:', e);
        } finally {
          setLoadingInitial(false);
        }
      })();
    }
  }, []);

  const handleCreated = async (newOrderId: string) => {
    console.log("handleCreated", newOrderId);
    setOrderId(newOrderId);
    try {
      await bxSaveOrderIdForCurrentDeal(newOrderId);
    } catch (e) {
      console.warn('OrderTab: не удалось сохранить orderId в FZ_ORDER: ', e)
      message.warning('Заявка создана, но не удалось сохранить её ID в Bitrix24');
    }
  }

  // Пока не попытались прочитать из entity — ничего лишнего не показываем
  if (loadingInitial) {
    return <div className="row muted">Загрузка…</div>;
  }

  if (!orderId) {
    return <GuaranteeStartFormWrapper onCreated={handleCreated} />;
  }

  return <OrderInfo orderId={orderId} />;
}
